import Vue from 'vue';
// import TransitionMusic from '@/components/TransitionMusic';

Vue.component('transition-music',
  () => import('@/components/TransitionMusic'));
